import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const TopToBottom = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility, { passive: true });

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`scroll-to-top-btn ${visible ? "is-visible" : ""}`}
    >
      <ChevronUp size={22} strokeWidth={2.5} />
    </button>
  );
};

export default TopToBottom;
